import { COMPANY } from "@/lib/company";

export default function TermsPage() {
  return (
    <div data-testid="terms-page" className="max-w-4xl mx-auto px-6 lg:px-8 py-20 lg:py-28 text-slate-300">
      <span className="text-red-500 font-display text-xs tracking-[0.3em] font-bold">LEGAL</span>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-white tracking-tighter mt-3">
        Terms of Use
      </h1>
      <p className="text-slate-500 text-sm mt-3">Last updated: {new Date().toLocaleDateString()}</p>

      <div className="prose prose-invert mt-10 space-y-6 leading-relaxed">
        <p>
          These Terms of Use govern your access to and use of the {COMPANY.name} website and the sourcing services offered through our corporate portal.
          By using this site, requesting a quote, or activating a portal license, you agree to these terms.
        </p>
        <h2 className="font-display text-2xl font-bold text-white mt-8">1. Sourcing Services</h2>
        <p>
          {COMPANY.name} provides B2B sourcing services across commercial real estate, turnkey solutions, property upkeep, wholesale assets, and business equipment. We act as a single accountable vendor coordinating delivery through our vetted partner network.
        </p>
        <h2 className="font-display text-2xl font-bold text-white mt-8">2. Portal Activation Fee</h2>
        <p>
          The $485 portal activation fee is a one-time, non-refundable license granting access to our sourcing desk, vendor network, and Sourcing Synergy clause. Pricing on individual sourced items is negotiated per-engagement.
        </p>
        <h2 className="font-display text-2xl font-bold text-white mt-8">3. Test Drive Voucher</h2>
        <p>
          The $9.95 3-Night Luxury Hotel Stay Voucher is a risk-free trial product. It carries no contract obligation, no recurring billing, and no presentation requirement. Standard property fees and incidentals are payable directly to the hotel.
        </p>
        <h2 className="font-display text-2xl font-bold text-white mt-8">4. Limitation of Liability</h2>
        <p>
          Services are provided on a best-effort basis through our partner network. {COMPANY.name} is not liable for delays or failures originating from third-party vendors beyond our reasonable control.
        </p>
        <h2 className="font-display text-2xl font-bold text-white mt-8">5. Contact</h2>
        <p>
          Questions about these terms? Contact <a href={COMPANY.emailLink} className="text-red-500 hover:underline">{COMPANY.email}</a> or call <a href={COMPANY.phoneLink} className="text-red-500 hover:underline">{COMPANY.phone}</a>.
        </p>
      </div>
    </div>
  );
}
